import { DOCUMENT } from '@angular/common';
import {
  Attribute,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Optional,
  ViewEncapsulation,
} from '@angular/core';

import { icon } from './icon.interface';
import { IconsRegistryService } from './icons-registry.service';

@Component({
  selector: 'app-icon',
  exportAs: 'appIcon',
  template: '<ng-content></ng-content>',
  host: { role: 'img' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class IconComponent implements OnInit {
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | 'full' = 'md';
  private svgIcon: SVGElement;

  constructor(
    @Optional() @Attribute('aria-hidden') ariaHidden: string,
    @Optional() @Inject(DOCUMENT) private document: Document,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly iconsRegistry: IconsRegistryService,
  ) {
    if (!ariaHidden) {
      elementRef.nativeElement.setAttribute('aria-hidden', 'true');
    }
    elementRef.nativeElement.classList.add('inline-block', 'fill-current');
  }

  @Input() set name(iconName: icon) {
    if (this.svgIcon) {
      this.elementRef.nativeElement.removeChild(this.svgIcon);
    }
    const svgData = this.iconsRegistry.getIcon(iconName);
    this.svgIcon = this.svgElementFromString(svgData);
    this.elementRef.nativeElement.appendChild(this.svgIcon);
  }

  ngOnInit(): void {
    switch (this.size) {
      case 'sm':
        this.elementRef.nativeElement.classList.add('h-4', 'max-h-4', 'w-4');
        break;
      case 'md':
        this.elementRef.nativeElement.classList.add('h-6', 'max-h-6', 'w-6');
        break;
      case 'lg':
        this.elementRef.nativeElement.classList.add('h-8', 'max-h-8', 'w-8');
        break;
      case 'xl':
        this.elementRef.nativeElement.classList.add('h-12', 'max-h-12', 'w-12');
        break;
      case 'full':
        this.elementRef.nativeElement.classList.add('h-auto', 'w-auto');
        break;
    }
  }

  private svgElementFromString(svgContent: string): SVGElement {
    const div = this.document.createElement('div');
    div.innerHTML = svgContent;
    return div.querySelector('svg') || this.document.createElementNS('http://www.w3.org/2000/svg', 'path');
  }
}
